module.exports = __webpack_public_path__ + "static/media/ic_addPicture.e0f06875.svg";